"use client";

import React from "react";
import { ArrowRight, Sparkles, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="llamado-a-la-acción" className="bg-background px-4 py-16 md:py-24 lg:px-8">
      <div ref={ref} className={`relative mx-auto max-w-5xl overflow-hidden rounded-[24px] bg-foreground px-6 py-16 text-center shadow-2xl transition-all duration-1000 sm:px-12 sm:py-20 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        {}
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_65%)] opacity-20 mix-blend-screen"></div>

        <div className="relative z-10 flex flex-col items-center gap-10">
          {}
          <h2 className="max-w-4xl font-sans text-3xl font-extrabold uppercase tracking-tight text-background sm:text-4xl md:text-5xl lg:text-6xl lg:leading-[1.1]">
            Comienza tu Carrera en Energías Renovables
          </h2>

          {}
          <div className="flex flex-col items-center gap-3 rounded-[24px] border border-border/10 bg-background/5 px-8 py-6 backdrop-blur-md sm:px-12">
            <div className="flex items-center gap-2 text-secondary">
              <Sparkles className="size-5" />
              <span className="font-mono text-sm font-bold uppercase tracking-wider">Inversión</span>
            </div>
            <div className="font-mono text-5xl font-bold text-background md:text-6xl">
              $20.000
              <span className="text-2xl font-medium text-background/60">
                /mes
              </span>
            </div>
            <p className="mt-1 font-mono text-sm text-background/70">
              Cupos limitados. Oferta por tiempo limitado.
            </p>
          </div>

          {}
          <div className="relative mt-4 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6">
            {}
            <div className="absolute -inset-4 animate-pulse rounded-[40px] bg-secondary opacity-20 blur-xl"></div>
            
            {}
            <Link to="https://mpago.la/1WfMEZk" newTab className="relative z-10 w-full sm:w-auto">
              <Button size="lg" className="group w-full rounded-[24px] bg-[#009EE3] px-10 py-8 text-lg font-bold text-white shadow-lg transition-all duration-300 hover:scale-105 hover:bg-[#008ED2] hover:shadow-2xl">
                <span className="flex items-center gap-3">
                  Pagar con Mercado Pago
                  <ArrowRight className="size-6 transition-transform duration-300 group-hover:translate-x-1.5" />
                </span>
              </Button>
            </Link>

            {}
            <Button asChild size="lg" className="group relative z-10 w-full overflow-hidden rounded-[24px] bg-[#25D366] px-10 py-8 text-lg font-bold text-white shadow-lg transition-all duration-300 hover:scale-105 hover:bg-[#22c35e] hover:shadow-2xl sm:w-auto">
              <Link to="https://wa.me/59896344395" newTab>
                <span className="relative z-10 flex items-center gap-3">
                  <MessageCircle className="size-6" />
                  Consultar por WhatsApp
                </span>
                {}
                <div className="absolute inset-0 bg-white/20 opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}